import { useTranslation } from '@/hooks/useTranslation';
import type { DocumentType } from '@/types/documentVault';
import styles from './DocumentTypeBadge.module.scss';

function badgeClass(type: DocumentType): string {
  switch (type) {
    case 'DOCUMENT':
      return styles.badgeNeutral ?? '';
    case 'ENVELOPE':
      return styles.badgeWarning ?? '';
  }
}

function DocumentTypeBadge({ type }: { type: DocumentType }) {
  const { t } = useTranslation();
  const label =
    type === 'ENVELOPE'
      ? t('K_BADGE_ENVELOPE', 'Envelope')
      : t('K_BADGE_DOCUMENT', 'Document');
  const title =
    type === 'ENVELOPE'
      ? t('K_HELP_ENVELOPE_READONLY', 'System-written by the contract signed handoff')
      : undefined;
  return (
    <span className={`${styles.badge} ${badgeClass(type)}`} title={title}>
      {label}
    </span>
  );
}

export default DocumentTypeBadge;
